import React from 'react';

const FormSubtitle = ({ children }) => (
  <h4 data-testid="app-form-subtitle" className="form__subtitle">
    {children}
  </h4>
);

export default FormSubtitle;
